"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.listItemActionBuilder = exports.ListItemAction = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItemActionSt = require("./ListItemAction.st.css");

var _constants = require("./constants");

var _Text = _interopRequireDefault(require("../Text"));

var _Box = _interopRequireDefault(require("../Box"));

var _Focusable = require("../common/Focusable");

var _context = require("../WixStyleReactProvider/context");

var _deprecationLog = _interopRequireDefault(require("../utils/deprecationLog"));

var _excluded = ["dataHook", "disabled", "skin", "prefixIcon", "onClick", "focusableOnFocus", "focusableOnBlur", "as", "tabIndex", "onKeyDown", "autoFocus", "highlighted", "className", "subtitle", "suffix"],
    _excluded2 = ["selected", "hovered", "ellipsis", "title", "shouldFocusWithoutScroll"],
    _excluded3 = ["title", "prefixIcon", "onClick", "id", "disabled", "skin", "size", "dataHook", "as", "tabIndex", "autoFocus", "className", "ellipsis", "subtitle", "suffix"];

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/ListItemAction/ListItemAction.js",
    _this3 = void 0;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** ListItemAction */
var ListItemActionComponent = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ListItemActionComponent, _React$PureComponent);

  var _super = _createSuper(ListItemActionComponent);

  function ListItemActionComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, ListItemActionComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderText", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          size = _this$props.size,
          ellipsis = _this$props.ellipsis,
          tooltipModifiers = _this$props.tooltipModifiers,
          subtitle = _this$props.subtitle,
          disabled = _this$props.disabled;
      return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
        direction: "vertical",
        className: _ListItemActionSt.classes.textBox,
        width: "100%",
        __self: (0, _assertThisInitialized2["default"])(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
        className: (0, _ListItemActionSt.st)(_ListItemActionSt.classes.text, {
          subtitle: Boolean(subtitle)
        }),
        dataHook: _constants.dataHooks.title,
        size: size,
        ellipsis: ellipsis,
        weight: "thin",
        placement: "right",
        skin: disabled ? 'disabled' : 'standard'
      }, tooltipModifiers, {
        __self: (0, _assertThisInitialized2["default"])(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89,
          columnNumber: 9
        }
      }), title), subtitle && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        dataHook: _constants.dataHooks.subtitle,
        secondary: true,
        size: "small",
        ellipsis: ellipsis,
        weight: "thin",
        placement: "right",
        skin: disabled ? 'disabled' : 'standard',
        light: !disabled,
        __self: (0, _assertThisInitialized2["default"])(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 11
        }
      }, subtitle));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderPrefix", function () {
      var _this$props2 = _this.props,
          prefixIcon = _this$props2.prefixIcon,
          size = _this$props2.size,
          subtitle = _this$props2.subtitle;
      return /*#__PURE__*/_react["default"].cloneElement(prefixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: (0, _ListItemActionSt.st)(_ListItemActionSt.classes.prefixIcon, {
          subtitle: Boolean(subtitle)
        }),
        'data-hook': _constants.dataHooks.prefixIcon
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderSuffix", function () {
      var _this$props3 = _this.props,
          suffix = _this$props3.suffix,
          size = _this$props3.size,
          ellipsis = _this$props3.ellipsis,
          disabled = _this$props3.disabled;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _ListItemActionSt.classes.suffix,
        __self: (0, _assertThisInitialized2["default"])(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 132,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        dataHook: _constants.dataHooks.suffix,
        secondary: true,
        size: size,
        light: !disabled,
        weight: "thin",
        skin: disabled ? 'disabled' : 'standard',
        ellipsis: ellipsis,
        children: suffix,
        __self: (0, _assertThisInitialized2["default"])(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133,
          columnNumber: 9
        }
      }));
    });
    return _this;
  }

  (0, _createClass2["default"])(ListItemActionComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.skin === 'dark') {
        (0, _deprecationLog["default"])('<ListItemAction/> - skin="dark" is deprecated and will be removed in next major version, please use skin="standard" instead');
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.innerComponentRef) {
        var scrollOptions = this.props.shouldFocusWithoutScroll ? {
          preventScroll: true
        } : {};
        this.innerComponentRef.focus(scrollOptions);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          dataHook = _this$props4.dataHook,
          disabled = _this$props4.disabled,
          skin = _this$props4.skin,
          prefixIcon = _this$props4.prefixIcon,
          onClick = _this$props4.onClick,
          focusableOnFocus = _this$props4.focusableOnFocus,
          focusableOnBlur = _this$props4.focusableOnBlur,
          Component = _this$props4.as,
          tabIndex = _this$props4.tabIndex,
          onKeyDown = _this$props4.onKeyDown,
          autoFocus = _this$props4.autoFocus,
          highlighted = _this$props4.highlighted,
          className = _this$props4.className,
          subtitle = _this$props4.subtitle,
          suffix = _this$props4.suffix,
          others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, _excluded); // since we're spreading the "rest" props, we don't want to pass

      var selected = others.selected,
          hovered = others.hovered,
          ellipsis = others.ellipsis,
          title = others.title,
          shouldFocusWithoutScroll = others.shouldFocusWithoutScroll,
          rest = (0, _objectWithoutPropertiesLoose2["default"])(others, _excluded2);
      return /*#__PURE__*/_react["default"].createElement(_context.WixStyleReactContext.Consumer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 185,
          columnNumber: 7
        }
      }, function (_ref) {
        var newColorsBranding = _ref.newColorsBranding;
        return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, rest, {
          className: (0, _ListItemActionSt.st)(_ListItemActionSt.classes.root, {
            skin: skin,
            disabled: disabled,
            highlighted: highlighted,
            ellipsis: ellipsis,
            newColorsBranding: newColorsBranding
          }, className),
          "data-skin": skin,
          "data-disabled": disabled,
          tabIndex: tabIndex,
          ref: function ref(_ref2) {
            return _this2.innerComponentRef = _ref2;
          },
          autoFocus: autoFocus,
          onFocus: focusableOnFocus,
          onBlur: focusableOnBlur,
          type: Component === 'button' ? 'button' : undefined,
          "data-hook": dataHook,
          onKeyDown: !disabled ? onKeyDown : undefined,
          onClick: !disabled ? onClick : undefined,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 187,
            columnNumber: 11
          }
        }), prefixIcon && _this2._renderPrefix(), _this2._renderText(), suffix && _this2._renderSuffix());
      });
    }
  }]);
  return ListItemActionComponent;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(ListItemActionComponent, "displayName", 'ListItemAction');
(0, _defineProperty2["default"])(ListItemActionComponent, "propTypes", {
  /** render as some other element */
  as: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].string]),

  /** Data attribute for testing purposes */
  dataHook: _propTypes["default"].string,

  /** Item theme (standard, dark, destructive) */
  skin: _propTypes["default"].oneOf(['standard', 'dark', 'destructive']),

  /** Text Size (small, medium) */
  size: _propTypes["default"].oneOf(['small', 'medium']),

  /** Prefix Icon */
  prefixIcon: _propTypes["default"].node,

  /** Suffix Node */
  suffix: _propTypes["default"].node,

  /** When present, it specifies that a button should automatically get focus when the page loads. */
  autoFocus: _propTypes["default"].bool,

  /** should the text get ellipsed with tooltip, or should it get broken into lines when it reaches the end of its container */
  ellipsis: _propTypes["default"].bool,

  /** Title */
  title: _propTypes["default"].string.isRequired,

  /** If true, the item is highlighted */
  highlighted: _propTypes["default"].bool,

  /** Disabled */
  disabled: _propTypes["default"].bool,

  /** Tooltip floating modifiers */
  tooltipModifiers: _propTypes["default"].object,

  /** On Click */
  onClick: _propTypes["default"].func,

  /** Text of the list item subtitle */
  subtitle: _propTypes["default"].string,

  /** Specifies whether page should be scrolled to the focused item */
  shouldFocusWithoutScroll: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(ListItemActionComponent, "defaultProps", {
  as: 'button',
  skin: 'standard',
  size: 'medium',
  highlighted: false
});
var ListItemAction = (0, _Focusable.withFocusable)(ListItemActionComponent);
exports.ListItemAction = ListItemAction;

var listItemActionBuilder = function listItemActionBuilder(_ref3) {
  var title = _ref3.title,
      prefixIcon = _ref3.prefixIcon,
      onClick = _ref3.onClick,
      id = _ref3.id,
      disabled = _ref3.disabled,
      skin = _ref3.skin,
      size = _ref3.size,
      dataHook = _ref3.dataHook,
      as = _ref3.as,
      tabIndex = _ref3.tabIndex,
      autoFocus = _ref3.autoFocus,
      className = _ref3.className,
      ellipsis = _ref3.ellipsis,
      subtitle = _ref3.subtitle,
      suffix = _ref3.suffix,
      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded3);
  return {
    id: id,
    disabled: disabled,
    overrideOptionStyle: true,
    value: function value(_ref4) {
      var hovered = _ref4.hovered;
      return /*#__PURE__*/_react["default"].createElement(ListItemAction, (0, _extends2["default"])({}, rest, {
        ellipsis: ellipsis,
        className: className,
        autoFocus: autoFocus,
        tabIndex: tabIndex,
        as: as,
        onClick: onClick,
        dataHook: dataHook,
        title: title,
        prefixIcon: prefixIcon,
        skin: skin,
        size: size,
        highlighted: hovered,
        disabled: disabled,
        subtitle: subtitle,
        suffix: suffix,
        __self: _this3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 240,
          columnNumber: 5
        }
      }));
    }
  };
};

exports.listItemActionBuilder = listItemActionBuilder;
//# sourceMappingURL=ListItemAction.js.map